export default __webpack_public_path__ + "static/media/561.b3aeb749.png";